var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.1914,
    cy: 38.9243,
    r: 38.5118,
    fill: "#2962FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8165 25.0338C42.7566 25.0231 42.695 25.0175 42.632 25.0175C42.569 25.0175 42.5074 25.0231 42.4475 25.0338H33.745C30.2859 25.0338 27.37 27.84 27.37 31.2628V46.1614C27.37 49.778 30.1578 52.6434 33.745 52.6434H44.8553C48.2671 52.6434 51.0843 49.6368 51.0843 46.1614V33.4142C51.0843 33.1449 50.9801 32.8861 50.7937 32.6918L43.7498 25.3545C43.5531 25.1496 43.2813 25.0338 42.9973 25.0338H42.8165ZM41.589 27.1187L33.745 27.1198C31.4205 27.1198 29.4561 29.0104 29.4561 31.2628V46.1614C29.4561 48.6385 31.3229 50.5574 33.745 50.5574H44.8553C47.0836 50.5574 48.9982 48.514 48.9982 46.1614L48.9973 34.7289L47.7798 34.7331C47.3158 34.7325 46.788 34.7315 46.2011 34.7302C43.7402 34.725 41.7318 32.7961 41.5963 30.3681L41.589 30.1061V27.1187ZM47.8558 32.6439L46.2057 32.6441C44.8074 32.6412 43.675 31.5058 43.675 30.1061V28.2891L47.8558 32.6439ZM42.3678 42.8291C42.9438 42.8291 43.4108 43.2961 43.4108 43.8721C43.4108 44.4002 43.0184 44.8366 42.5093 44.9056L42.3678 44.9151H34.8621C34.2861 44.9151 33.8191 44.4482 33.8191 43.8721C33.8191 43.3441 34.2115 42.9077 34.7206 42.8386L34.8621 42.8291H42.3678ZM40.5717 36.9851C40.5717 36.409 40.1047 35.942 39.5286 35.942H34.8614L34.7199 35.9516C34.2108 36.0206 33.8184 36.457 33.8184 36.9851C33.8184 37.5611 34.2854 38.0281 34.8614 38.0281H39.5286L39.6702 38.0186C40.1793 37.9495 40.5717 37.5131 40.5717 36.9851Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/knowledge.f083a9c4c533dae6705e2dd33b7eae1a.svg";
export { ForwardRef as ReactComponent };